module.exports = __webpack_public_path__ + "img/dots.9e8c2038.svg";